import React from 'react';
import {FlatList, View} from 'react-native';
import {observer} from 'mobx-react';

import {DEFAULT_CAROUSEL_NUM_ITEMS} from '../../constants/GlobalConstants';
import {useWebScreenDimensions} from '../../hooks/useWebScreenDimensions';
import {AirtablePromotionItem} from '../../models/airtable';
import {useStores} from '../../stores/use-stores';
import { brandRewardsCopy } from '../../utils/rewards';
import TitleLine from '../rewards/TitleLine';
import TileLarge from '../TileLarge';
type PromotionsCarouselProps = {
  onPromotionPress?: any;
  onSeeAllPress?: any;
  numItems?: number;
};

const PromotionsCarousel = observer(
  ({
    onPromotionPress,
    onSeeAllPress,
    numItems = DEFAULT_CAROUSEL_NUM_ITEMS,
  }: PromotionsCarouselProps) => {
    const {promotionsStore} = useStores();

    const renderItem = createRenderItem(onPromotionPress);

    const {isWebDesktopScreen} = useWebScreenDimensions();

    return (
      <View>
        <TitleLine title={brandRewardsCopy.promotionsTitle.toUpperCase()} onSeeAllPress={onSeeAllPress} />
        <FlatList
          horizontal
          data={promotionsStore.carouselData?.slice(0, numItems) || []}
          renderItem={renderItem}
          ItemSeparatorComponent={Separator}
          showsHorizontalScrollIndicator={isWebDesktopScreen}
        />
      </View>
    );
  },
);

function Separator() {
  return <View style={{width: 8, height: 8}} />;
}

const createRenderItem =
  (onPromotionPress: any) =>
  ({item}: {item: AirtablePromotionItem}) => {
    return (
      <TileLarge
        title={item.headline}
        description={item.description}
        image={item.heroImage!}
        onPress={() => onPromotionPress(item)}
      />
    );
  };

export default PromotionsCarousel;
